/* LP VIP Access Black Week : capture email (Supabase attribuée puis Klaviyo, succès seulement si les
   deux répondent), puis 2e étape WhatsApp facultative vers l'edge function waitlist-whatsapp.
   Compte à rebours et clôture lus dans le navigateur : la page servie peut venir du cache. */
(function () {
  'use strict';
  var WAITLIST = 'vip-black-week-2026';
  var SUPABASE = 'https://eluljtthflzzsmrcoqlg.supabase.co';
  var PUBLIC_KEY = 'sb_publishable_QthosKqCipG4xedUnfPoaw_ooG-8YjW';

  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var forms = Array.from(root.querySelectorAll('[data-vipbw-form]'));
    var closeAt = Date.parse(root.dataset.close || '');
    var busy = false;
    var savedEmail = null;
    var lang = (root.dataset.language || 'fr').slice(0, 2).toUpperCase();

    /* ---- Clôture et compte à rebours ---- */
    // plein : les places VIP sont toutes prises (jauge). Ferme comme la date de fin.
    var plein = false;
    function closed() { return plein || (!isNaN(closeAt) && Date.now() >= closeAt); }
    function applyClosed(full) {
      if (full) root.querySelectorAll('[data-vipbw-closed] [data-full]').forEach(function (n) { n.textContent = n.dataset.full; });
      root.querySelectorAll('[data-vipbw-ref],[data-vipbw-gauge],[data-vipbw-invite],[data-vipbw-color]').forEach(function (n) { n.hidden = true; });
      forms.forEach(function (f) { f.hidden = true; });
      root.querySelectorAll('[data-vipbw-wa]').forEach(function (w) { w.hidden = true; });
      root.querySelectorAll('[data-vipbw-open]').forEach(function (n) { n.hidden = true; });
      root.querySelectorAll('[data-vipbw-closed]').forEach(function (n) { n.hidden = false; });
      var c = root.querySelector('[data-vipbw-count]');
      if (c) c.hidden = true;
      stickyOff = true; updateSticky();
    }

    /* ---- Barre collante mobile : visible quand aucune carte d'inscription n'est à l'écran ---- */
    var sticky = root.querySelector('[data-vipbw-sticky]');
    var stickyOff = false;
    var seen = new Map();
    function updateSticky() {
      if (!sticky) return;
      var anyCard = false;
      seen.forEach(function (v) { if (v) anyCard = true; });
      var below = root.getBoundingClientRect().top < 0;
      sticky.hidden = stickyHold ? false : (stickyOff || anyCard || !below);
      root.classList.toggle('vipbw--sticky-on', !sticky.hidden);
      if (!sticky.hidden) root.style.setProperty('--vipbw-sticky-h', (sticky.offsetHeight + 8) + 'px');
    }
    // stickyHold : l'email vient d'être tapé dans la barre, elle reste ouverte pour l'étape WhatsApp.
    var stickyHold = false;
    function releaseSticky() {
      setTimeout(function () { stickyHold = false; stickyOff = true; updateSticky(); }, 2500);
    }
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
        updateSticky();
      }, {threshold: 0.15});
      root.querySelectorAll('[data-vipbw-topcard],[data-vipbw-bottomcard],[data-vipbw-bannercard]').forEach(function (n) { io.observe(n); });
      window.addEventListener('scroll', updateSticky, {passive: true});
    }
    var count = root.querySelector('[data-vipbw-count]');
    function tick() {
      if (closed()) { applyClosed(); return false; }
      if (!count || isNaN(closeAt)) return true;
      var left = Math.max(0, closeAt - Date.now());
      var d = Math.floor(left / 86400000), h = Math.floor(left / 3600000) % 24, m = Math.floor(left / 60000) % 60;
      count.querySelector('[data-u="d"]').textContent = d;
      count.querySelector('[data-u="h"]').textContent = h;
      count.querySelector('[data-u="m"]').textContent = m;
      count.hidden = false;
      return true;
    }
    /* ---- Minuteur du Black Friday (bandeau du haut) : jours restants, recalculés ici car la page peut venir du cache ---- */
    var bfBox = root.querySelector('[data-vipbw-bf]');
    var bfLine = root.querySelector('[data-vipbw-bf-line]');
    function tickBf() {
      if (!bfBox || !bfLine) return;
      var left = Date.parse(bfBox.dataset.vipbwBf || '') - Date.now();
      if (isNaN(left) || left <= 0) { bfLine.hidden = true; return; }
      var days = Math.ceil(left / 86400000);
      bfLine.innerHTML = days === 1 ? bfLine.dataset.one : bfLine.dataset.other.replace('__N__', days);
    }
    tickBf();
    setInterval(tickBf, 60000);

    /* ---- Avis écrit de la cliente sous son avant/après (by-color/avis.json, tenu par avant-apres-avis.py) ---- */
    var aa = root.querySelector('[data-vipbw-aa]');
    if (aa && window.fetch) {
      var langue = root.dataset.language || 'fr';
      fetch('https://eluljtthflzzsmrcoqlg.supabase.co/storage/v1/object/public/omads-brand/photos/results/by-color/avis.json')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.avis) return;
          aa.querySelectorAll('.aag__item img').forEach(function (img) {
            var m = (img.getAttribute('src') || '').match(/by-color\/([a-z]+)\/(\d+)\.jpg/);
            var a = m && data.avis[m[1] + '/' + m[2]];
            if (!a) return;
            var texte = a.t[langue] || a.t[langue.slice(0, 2)] || a.t.fr || a.t.en;
            if (!texte) return;
            var box = document.createElement('div');
            box.className = 'vipbw-rv';
            var stars = document.createElement('span');
            stars.className = 'vipbw-rv__stars';
            stars.setAttribute('aria-label', a.n + '/5');
            stars.textContent = '★★★★★'.slice(0, Math.max(1, Math.min(5, a.n)));
            var p = document.createElement('p');
            p.className = 'vipbw-rv__txt';
            p.textContent = texte;
            var who = document.createElement('p');
            who.className = 'vipbw-rv__who';
            who.textContent = a.p;
            box.appendChild(stars); box.appendChild(p);
            if (texte.length > 150) {
              var more = document.createElement('button');
              more.type = 'button'; more.className = 'vipbw-rv__more';
              more.textContent = aa.dataset.more;
              more.addEventListener('click', function () { box.classList.add('vipbw-rv--open'); more.remove(); });
              box.appendChild(more);
            }
            box.appendChild(who);
            img.parentNode.appendChild(box);
          });
        })
        .catch(function () { /* Sans avis, les photos s'affichent seules. */ });
    }

    if (tick()) {
      var timer = setInterval(function () { if (!tick()) clearInterval(timer); }, 30000);
    } else return;

    /* ---- Parrainage : invite 2 amies (edge function vip-bw-parrainage) ---- */
    var FN = SUPABASE + '/functions/v1/vip-bw-parrainage';
    var STORE = 'omads_vip_bw_moi';
    function alea(n, alphabet) {
      var o = new Uint8Array(n); crypto.getRandomValues(o);
      return Array.from(o, function (b) { return alphabet[b % alphabet.length]; }).join('');
    }
    function fn(payload) {
      return fetch(FN, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(payload)})
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    // Le code de l'URL d'abord en mémoire : un stockage bloqué ne doit pas perdre le parrainage.
    var v = (new URLSearchParams(window.location.search).get('vip') || '').toUpperCase();
    var parrain = /^[A-Z0-9]{10}$/.test(v) ? v : null;
    try {
      if (parrain) sessionStorage.setItem('omads_vip_bw_parrain', parrain);
      else parrain = sessionStorage.getItem('omads_vip_bw_parrain');
    } catch (_) {}
    if (parrain) root.querySelectorAll('[data-vipbw-invite]').forEach(function (n) { n.hidden = false; });
    // moi : inscription terminée (email + Klaviyo). enCours : ligne posée en base, Klaviyo pas
    // encore confirmé ; gardée pour qu'une reprise, même après rechargement, garde son code.
    var moi = null, enCours = null;
    try {
      moi = JSON.parse(localStorage.getItem(STORE) || 'null');
      enCours = JSON.parse(localStorage.getItem(STORE + '_attente') || 'null');
    } catch (_) {}
    function lienParrainage() {
      return window.location.origin + window.location.pathname + '?vip=' + moi.code;
    }
    function afficherEtat(etat) {
      if (!etat) return;
      var n = Math.min(2, etat.filleules || 0);
      root.querySelectorAll('[data-vipbw-ref]').forEach(function (box) {
        box.querySelectorAll('[data-vipbw-ref-dot]').forEach(function (d, i) { d.classList.toggle('on', i < n); });
        var c = box.querySelector('[data-vipbw-ref-count]');
        if (c) { c.textContent = c.dataset.tpl.replace('__N__', n); c.hidden = !!etat.debloque; }
        var done = box.querySelector('[data-vipbw-ref-done]');
        if (done) done.hidden = !etat.debloque;
      });
    }
    function rafraichir() {
      if (moi && moi.jeton) fn({action: 'etat', email: moi.email, jeton: moi.jeton}).then(afficherEtat);
    }
    function montrerParrainage() {
      if (!moi || !moi.code) return;
      root.querySelectorAll('[data-vipbw-invite]').forEach(function (n) { n.hidden = true; });
      var lien = lienParrainage();
      var msg = root.dataset.refMsg + '\n' + lien;
      root.querySelectorAll('[data-vipbw-ref]').forEach(function (box) {
        box.hidden = false;
        var wa = box.querySelector('[data-vipbw-ref-wa]');
        if (wa) wa.href = 'https://wa.me/?text=' + encodeURIComponent(msg);
        var copy = box.querySelector('[data-vipbw-ref-copy]');
        if (copy && !copy.dataset.ready) {
          copy.dataset.ready = '1';
          var label = copy.textContent;
          copy.addEventListener('click', function () {
            // Sur téléphone, le menu de partage du système ; sinon le lien copié.
            if (navigator.share) { navigator.share({text: msg}).catch(function () {}); return; }
            (navigator.clipboard ? navigator.clipboard.writeText(lien) : Promise.reject()).then(function () {
              copy.textContent = copy.dataset.ok;
              setTimeout(function () { copy.textContent = label; }, 2000);
            }).catch(function () { window.prompt('', lien); });
          });
        }
      });
      rafraichir();
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) rafraichir(); });
    /* ---- Question couleur + popup d'éducation (29/10/2026, décision Julien) ----
       Insérée ENTRE l'étape WhatsApp et le parrainage : le parrainage reste caché tant que la question
       n'a ni réponse ni « Passer » (une seule chose à la fois, la jauge et la clôture ne bougent pas).
       Une inscrite qui revient avec WhatsApp déjà passé et sans couleur la voit À CÔTÉ de son parrainage,
       une seule fois (moi.couleur). Edge function waitlist-couleur (omads-ops), réessai unique après 2 s
       si l'inscription email n'est pas encore en base (« not_subscribed »), comme la LP Biscuit. */
    var couleurFaite = !!(moi && moi.couleur);
    var colorBlocks = Array.from(root.querySelectorAll('[data-vipbw-color]'));
    var pop = root.querySelector('[data-vipbw-pop]');
    var popBox = pop ? pop.querySelector('[data-vipbw-pop-box]') : null;
    function popFocusables() {
      return Array.prototype.filter.call(popBox.querySelectorAll('a[href], button:not([disabled])'), function (el) { return el.offsetParent !== null; });
    }
    // Les images ne se chargent qu'à l'étape couleur : un parent caché les télécharge quand même si elles ont un src.
    function chargerImagesPopup() {
      if (!pop) return;
      // Clonées depuis un <template> plutôt que recopiées de data-src vers src : aucun texte du DOM n'est réinterprété (CodeQL).
      pop.querySelectorAll('template[data-vipbw-img]').forEach(function (t) { t.replaceWith(t.content.cloneNode(true)); });
    }
    function fermerPopup() {
      if (!pop || pop.hidden) return;
      pop.hidden = true;
      document.body.style.overflow = pop.vipbwScroll || '';
      var o = pop.vipbwOrigine;
      if (o && o.focus && document.contains(o)) { try { o.focus(); } catch (_) {} }
      pop.vipbwOrigine = null;
    }
    function ouvrirPopup(titreId, retour) {
      chargerImagesPopup();
      pop.vipbwOrigine = retour;
      popBox.setAttribute('aria-labelledby', titreId);
      // Sans code de parrainage (inscrite avant ce navigateur), il n'y a rien vers quoi mener : le bouton disparait.
      pop.querySelector('[data-vipbw-pop-invite]').hidden = !(moi && moi.code);
      pop.vipbwScroll = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      pop.hidden = false;
      popBox.scrollTop = 0;
      popBox.focus();
    }
    if (pop) {
      pop.addEventListener('click', function (e) { if (e.target === pop) fermerPopup(); });
      pop.querySelector('[data-vipbw-pop-close]').addEventListener('click', fermerPopup);
      // « J'invite une amie » : la popup se ferme, la page défile jusqu'au bloc de parrainage affiché et y pose le focus.
      pop.querySelector('[data-vipbw-pop-invite]').addEventListener('click', function () {
        pop.vipbwOrigine = null;
        fermerPopup();
        var cible = Array.from(root.querySelectorAll('[data-vipbw-ref]')).filter(function (b) { return !b.hidden && b.offsetParent !== null; })[0];
        if (!cible) return;
        cible.scrollIntoView({behavior: 'smooth', block: 'center'});
        var bouton = cible.querySelector('[data-vipbw-ref-copy],[data-vipbw-ref-wa]');
        if (bouton) { try { bouton.focus({preventScroll: true}); } catch (_) {} }
      });
      document.addEventListener('keydown', function (e) {
        if (pop.hidden) return;
        if (e.key === 'Escape') { e.preventDefault(); fermerPopup(); return; }
        if (e.key !== 'Tab') return;
        var f = popFocusables();
        if (!f.length) { e.preventDefault(); popBox.focus(); return; }
        var premier = f[0], dernier = f[f.length - 1];
        if (!popBox.contains(document.activeElement)) { e.preventDefault(); premier.focus(); }
        else if (e.shiftKey && (document.activeElement === premier || document.activeElement === popBox)) { e.preventDefault(); dernier.focus(); }
        else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
      });
    }
    function couleurTerminee(done) {
      couleurFaite = true;
      if (moi) { moi.couleur = true; try { localStorage.setItem(STORE, JSON.stringify(moi)); } catch (_) {} }
      colorBlocks.forEach(function (b) {
        if (!done) { b.hidden = true; return; }
        ['.vipbw-wa__title', '.vipbw-color__sub', '[data-vipbw-color-opts]', '[data-vipbw-color-error]', '[data-vipbw-color-skip]'].forEach(function (sel) {
          var n = b.querySelector(sel); if (n) n.hidden = true;
        });
        b.querySelector('[data-vipbw-color-done]').hidden = false;
      });
      montrerParrainage();
    }
    function envoyerCouleur(couleur, essai) {
      return fetch(SUPABASE + '/functions/v1/waitlist-couleur', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({waitlist: WAITLIST, email: savedEmail, hair_color: couleur, language: lang, page_url: window.location.pathname + window.location.search})
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (j) {
          if (res.ok && j.ok) return j;
          if (j.error === 'not_subscribed' && essai === 0) {
            return new Promise(function (r) { setTimeout(r, 2000); }).then(function () { return envoyerCouleur(couleur, 1); });
          }
          throw new Error(j.error || String(res.status));
        });
      });
    }
    function montrerCouleur() {
      if (closed() || couleurFaite || !colorBlocks.length) return;
      chargerImagesPopup();
      var depuisBarre = stickyHold;
      colorBlocks.forEach(function (b) {
        b.hidden = false;
        if (b.dataset.ready) return;
        b.dataset.ready = '1';
        var opts = Array.from(b.querySelectorAll('[data-color]'));
        var err = b.querySelector('[data-vipbw-color-error]');
        b.querySelector('[data-vipbw-color-skip]').addEventListener('click', function () { couleurTerminee(false); });
        opts.forEach(function (opt) {
          opt.addEventListener('click', function () {
            if (opt.disabled || !savedEmail) return;
            err.hidden = true;
            // Les options de TOUTES les cartes se figent : une seule réponse par visiteuse.
            var toutes = root.querySelectorAll('.vipbw-color__opt');
            toutes.forEach(function (o) { o.disabled = true; o.classList.toggle('is-selected', o.getAttribute('data-color') === opt.getAttribute('data-color')); });
            var couleur = opt.getAttribute('data-color');
            envoyerCouleur(couleur, 0).then(function () {
              couleurTerminee(true);
              if (!pop) return;
              var blond = couleur === 'Blond';
              pop.querySelector('[data-vipbw-result-blond]').hidden = !blond;
              pop.querySelector('[data-vipbw-result-chatain]').hidden = blond;
              ouvrirPopup(blond ? 'vipbw-pop-title-blond-' + pop.id.replace('vipbw-pop-', '') : 'vipbw-pop-title-chatain-' + pop.id.replace('vipbw-pop-', ''), b.querySelector('[data-vipbw-color-done]'));
            }).catch(function () {
              err.textContent = root.dataset.error;
              err.hidden = false;
              toutes.forEach(function (o) { o.disabled = false; o.classList.remove('is-selected'); });
            });
          });
        });
      });
      // Inscrite depuis la barre fixe (qui disparait): la question est dans une carte, hors écran. On l'y amène.
      if (depuisBarre) {
        var carte = colorBlocks.filter(function (b) { return b.offsetParent !== null && !b.closest('[data-vipbw-sticky]'); })[0];
        if (carte) {
          carte.scrollIntoView({behavior: 'smooth', block: 'center'});
          var premiere = carte.querySelector('[data-color]');
          if (premiere) { try { premiere.focus({preventScroll: true}); } catch (_) {} }
        }
      }
    }
    // Fin de l'étape WhatsApp : la couleur d'abord, le parrainage ensuite (ou tout de suite si elle est déjà faite).
    function apresWhatsapp() {
      if (couleurFaite || closed() || !savedEmail) montrerParrainage(); else montrerCouleur();
    }
    // Inscrite qui revient sur ce navigateur : directement son lien de parrainage, pas de formulaire.
    // Étape WhatsApp pas terminée : elle revient ; sinon directement le lien de parrainage.
    var reprendreWa = false;
    if (moi && moi.code) {
      stickyOff = true; updateSticky();
      if (moi.wa) { forms.forEach(function (f) { f.hidden = true; }); savedEmail = moi.email; montrerParrainage(); montrerCouleur(); }
      else reprendreWa = true;
    }

    /* ---- Jauge des places : réelle, affichée à partir d'un seuil, inscriptions fermées au plafond ---- */
    var max = parseInt(root.dataset.max, 10) || 10000;
    var seuil = parseInt(root.dataset.seuil, 10) || 0;
    var gauges = root.querySelectorAll('[data-vipbw-gauge]');
    var locale = root.dataset.language || 'fr';
    function jauge() {
      if (closed()) return;
      fn({action: 'compte'}).then(function (r) {
        // Clôture survenue pendant la requête : rien ne se réaffiche.
        if (!r || typeof r.inscrites !== 'number' || closed()) return;
        // Plafond atteint : fermé aux nouvelles seulement. Une inscrite (ou une inscription en
        // cours) garde son étape WhatsApp et son parrainage.
        if (r.inscrites >= max) {
          if (!moi && !busy) { plein = true; applyClosed(true); }
          gauges.forEach(function (g) { g.hidden = true; });
          return;
        }
        if (r.inscrites < seuil) return;
        gauges.forEach(function (g) {
          g.querySelector('[data-vipbw-gauge-fill]').style.width = Math.max(2, Math.round(r.inscrites / max * 100)) + '%';
          g.querySelector('[data-vipbw-gauge-txt]').textContent = g.dataset.tpl
            .replace('__N__', r.inscrites.toLocaleString(locale))
            .replace('__RESTE__', (max - r.inscrites).toLocaleString(locale))
            .replace('__MAX__', max.toLocaleString(locale));
          g.hidden = false;
        });
      });
    }
    jauge();
    // Elle avance pendant que la visiteuse lit : relue chaque minute, page visible seulement.
    setInterval(function () { if (!document.hidden && !closed()) jauge(); }, 60000);

    /* ---- Attribution ---- */
    var qs = new URLSearchParams(window.location.search);
    var utm = {};
    ['source', 'medium', 'campaign', 'content', 'term'].forEach(function (key) {
      utm['utm_' + key] = qs.get('utm_' + key) || null;
    });
    var landing = window.location.pathname + window.location.search;
    var storageKey = 'omads_vip_bw_attribution';
    try {
      if (utm.utm_source) sessionStorage.setItem(storageKey, JSON.stringify({utm: utm, landing: landing}));
      else {
        var saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (saved && saved.utm) { utm = saved.utm; landing = saved.landing || landing; }
      }
    } catch (_) { /* La capture reste possible si le navigateur bloque le stockage. */ }
    function channel() {
      if (utm.utm_source) return utm.utm_source.toLowerCase();
      var ref = document.referrer || '';
      if (/facebook|instagram|fb\./i.test(ref)) return 'meta';
      if (/tiktok/i.test(ref)) return 'tiktok';
      if (/google/i.test(ref)) return 'google';
      return 'site';
    }
    async function post(url, headers, payload) {
      var controller = new AbortController();
      var t = setTimeout(function () { controller.abort(); }, 20000);
      try {
        return await fetch(url, {method: 'POST', headers: headers, body: JSON.stringify(payload), signal: controller.signal});
      } finally { clearTimeout(t); }
    }
    async function capture(email, meta) {
      var response = await post(SUPABASE + '/rest/v1/waitlist_subscriptions', {
        'Content-Type': 'application/json', apikey: PUBLIC_KEY, Authorization: 'Bearer ' + PUBLIC_KEY, Prefer: 'return=minimal'
      }, Object.assign({}, utm, {
        waitlist_name: WAITLIST, email: email,
        source: 'lp-vip-access-black-week', klaviyo_list_id: root.dataset.list,
        channel: channel(), page_url: landing, language: lang,
        referrer: document.referrer || null, user_agent: navigator.userAgent || null,
        metadata: meta
      }));
      if (response.ok) return true;
      {
        // La contrainte UNIQUE (liste, email) confirme une inscription déjà enregistrée.
        var error = await response.json().catch(function () { return {}; });
        if (response.status !== 409 || error.code !== '23505') throw new Error('vip_capture_failed');
        return false;
      }
    }
    async function subscribe(email) {
      var response = await post('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.company), {
        accept: 'application/json', 'content-type': 'application/json', revision: '2024-10-15'
      }, {data: {
        type: 'subscription', attributes: {
          custom_source: 'LP VIP Access Black Week 2026',
          profile: {data: {type: 'profile', attributes: {email: email, properties: {
            vip_black_week_2026: true, waitlist_source: WAITLIST,
            signup_date: new Date().toISOString(), wl_channel: channel(),
            wl_utm_source: utm.utm_source || 'organique', wl_utm_medium: utm.utm_medium || '',
            wl_utm_campaign: utm.utm_campaign || '', wl_utm_content: utm.utm_content || '',
            // `lang` = la seule propriété que lisent les segments de langue (10/10/2026).
            lang: lang
          }}}}
        }, relationships: {list: {data: {type: 'list', id: root.dataset.list}}}
      }});
      if (!response.ok) throw new Error('vip_subscription_failed');
    }

    /* ---- Étape WhatsApp : même normalisation E.164 que le popup et la LP Biscuit ---- */
    function versE164(prefix, saisie) {
      var brut = String(saisie || '').trim();
      var chiffres = brut.replace(/\D/g, '');
      var e164;
      if (brut.charAt(0) === '+') e164 = '+' + chiffres;
      else if (chiffres.indexOf('00') === 0) e164 = '+' + chiffres.slice(2);
      else e164 = '+' + prefix + chiffres.replace(/^0+/, '');
      if (!/^\+[1-9]\d{7,14}$/.test(e164)) return null;
      var nat = { '352': [6, 11], '351': [9, 9], '353': [9, 9], '33': [9, 9], '32': [8, 9], '41': [9, 9],
                  '34': [9, 9], '39': [9, 11], '49': [10, 12], '43': [10, 13], '31': [9, 9], '48': [9, 9], '30': [10, 10] };
      for (var ind in nat) {
        if (e164.indexOf('+' + ind) === 0) {
          var reste = e164.length - 1 - ind.length;
          return (reste >= nat[ind][0] && reste <= nat[ind][1]) ? e164 : null;
        }
      }
      return e164;
    }
    function showWhatsapp(form) {
      var card = form.parentElement;
      var box = card.querySelector('[data-vipbw-wa]');
      form.hidden = true;
      if (!box) return;
      box.hidden = false;
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var waForm = box.querySelector('[data-vipbw-wa-form]');
      if (!waForm) return;
      var waInput = waForm.querySelector('[name="wa_number"]');
      var waBtn = waForm.querySelector('button');
      var waBtnText = waBtn.textContent;
      var waErr = box.querySelector('[data-vipbw-wa-error]');
      var skip = box.querySelector('[data-vipbw-wa-skip]');
      function finish(doneSel) {
        // Le numéro donné (ou refusé) dans la barre vaut pour les cartes, et inversement.
        root.querySelectorAll('[data-vipbw-wa]').forEach(function (b) {
          ['[data-vipbw-wa-form]', '[data-vipbw-wa-skip]', '[data-vipbw-wa-error]', '.vipbw-wa__legal', '.vipbw-wa__text', '.vipbw-wa__title'].forEach(function (sel) {
            var n = b.querySelector(sel); if (n) n.hidden = true;
          });
          var done = b.querySelector(doneSel); if (done) done.hidden = false;
        });
        if (stickyHold) releaseSticky();
        if (moi) { moi.wa = true; try { localStorage.setItem(STORE, JSON.stringify(moi)); } catch (_) {} }
        apresWhatsapp();
      }
      waInput.addEventListener('input', function () { waErr.hidden = true; });
      if (skip) skip.addEventListener('click', function () { finish('[data-vipbw-wa-skipped]'); });
      waForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (waBtn.disabled) return;
        var numero = versE164(waForm.querySelector('[name="wa_prefix"]').value, waInput.value);
        if (!numero) { waErr.textContent = waErr.getAttribute('data-invalid'); waErr.hidden = false; return; }
        waErr.hidden = true;
        waBtn.disabled = true;
        waBtn.textContent = root.dataset.loading;
        fetch(SUPABASE + '/functions/v1/waitlist-whatsapp', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ waitlist: WAITLIST, email: savedEmail, whatsapp: numero, language: lang, page_url: landing })
        })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (j) {
            if (!res.ok || !j.ok) throw new Error(j.error || String(res.status));
          });
        })
        .then(function () { finish('[data-vipbw-wa-done]'); })
        .catch(function (err) {
          // Jamais « c'est noté » sans réponse positive du serveur.
          waErr.textContent = err && err.message === 'bad_whatsapp' ? waErr.getAttribute('data-invalid') : root.dataset.error;
          waErr.hidden = false;
          waBtn.disabled = false;
          waBtn.textContent = waBtnText;
        });
      });
    }

    if (reprendreWa) { savedEmail = moi.email; forms.forEach(showWhatsapp); }

    forms.forEach(function (form) {
      var input = form.querySelector('input[type="email"]');
      var button = form.querySelector('button');
      var feedback = form.querySelector('[data-vipbw-feedback]');
      var original = button.textContent;
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (busy) return;
        if (closed()) { applyClosed(); return; }
        input.value = input.value.trim().toLowerCase();
        if (!form.reportValidity()) return;
        if (!root.dataset.list || !root.dataset.company) { feedback.textContent = root.dataset.error; return; }
        var email = input.value;
        busy = true;
        forms.forEach(function (f) { f.querySelector('button').disabled = true; f.querySelector('input').disabled = true; });
        button.textContent = root.dataset.loading;
        feedback.textContent = '';
        try {
          var AN = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
          // Les identifiants de la tentative sont gardés AVANT l'envoi : une réponse perdue ou un
          // échec Klaviyo, puis une reprise (même après rechargement), réutilisent les mêmes, et
          // le 409 de la reprise désigne alors bien la ligne posée par cette tentative.
          var reprise = enCours && enCours.email === email;
          var tentative = reprise ? enCours : {email: email, code: alea(10, AN), jeton: alea(32, AN + 'abcdefghijkmnpqrstuvwxyz')};
          enCours = tentative;
          try { localStorage.setItem(STORE + '_attente', JSON.stringify(enCours)); } catch (_) {}
          var meta = {code_parrainage: tentative.code, jeton: tentative.jeton};
          if (parrain) meta.parrain = parrain;
          // 409 sans tentative antérieure : inscrite AVANT ce navigateur, son code est inconnu ici.
          var enAttente = false;
          if (!(await capture(email, meta))) {
            // 409 : la ligne existait. Sur une reprise, elle n'est la nôtre que si le serveur
            // reconnaît email + jeton. Refus confirmé (403/404) ou pas de reprise : identifiants
            // effacés. Serveur injoignable : gardés en attente, sans lien affiché pour l'instant.
            var statut = 0;
            if (reprise) {
              statut = await fetch(FN, {method: 'POST', headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({action: 'etat', email: email, jeton: tentative.jeton})})
                .then(function (r) { return r.status; }).catch(function () { return 0; });
            }
            if (!reprise || statut === 403 || statut === 404) {
              enCours = null;
              try { localStorage.removeItem(STORE + '_attente'); } catch (_) {}
            } else if (statut !== 200) enAttente = true;
          }
          await subscribe(email);
          savedEmail = email;
          // Déjà inscrite avant (409) : sa ligne garde l'ancien code, inconnu ici, donc pas de parrainage.
          if (enCours && enCours.email === email && !enAttente) {
            moi = enCours;
            try { localStorage.setItem(STORE, JSON.stringify(moi)); localStorage.removeItem(STORE + '_attente'); } catch (_) {}
            // Filleule : la vérification du trio de sa marraine part tout de suite.
            if (parrain) rafraichir();
          }
          // Tapé dans la barre : elle reste pour le WhatsApp. Tapé dans une carte : la barre s'efface.
          if (sticky && sticky.contains(form)) {
            stickyHold = true;
            var stText = sticky.querySelector('.vipbw-sticky__text');
            if (stText) stText.hidden = true;
          } else stickyOff = true;
          updateSticky();
          // L'étape WhatsApp prend la place de CHAQUE formulaire email de la page.
          forms.forEach(showWhatsapp);
        } catch (error) {
          feedback.textContent = root.dataset.error;
          button.textContent = original;
          forms.forEach(function (f) { f.querySelector('button').disabled = false; f.querySelector('input').disabled = false; });
          busy = false;
          // Pas d'email dans le journal de diagnostic du navigateur.
          console.error('[vip-black-week] Échec de capture ou de consentement', error.name);
        }
      });
    });
  }
  function all() { document.querySelectorAll('[data-vipbw]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', all);
})();
